/****************************************************
 * Module Name:  milkyProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class MilkyProxy {
  static GetAllMilky = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/milky",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleMilky = (milkyId, callback) => {
    let params = {
      id: milkyId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/milky",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMilkyMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/milky/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };


  static CheckMilkyAvailable = (milky, callback) => {
    let params = {
      milky: milky,
    };

    restAPICall(
      Constants.MANAGER_URL + "/milky/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddMilky = (milky, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/milky",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(milky),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateMilky = (milky, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/milky",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(milky),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteMilky = (milky, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/milky",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(milky),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
